const blockSliderInit = () => {
    const sliders = Array.from(document.querySelectorAll('.bn-block-slider .swiper'));

    if (sliders) {
        sliders.forEach(slider => {
            if (slider) {
                const sliderConfig = {
                    observer: true,
                    observeSlideChildren: true,
                    loop: true,
                    autoplay: {
                        delay: 5000,
                    },
                    slidesPerView: 1,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    allowTouchMove: slider.dataset.allowtouchmove === "0",
                    navigation: {
                        nextEl: slider.parentNode.querySelector(".swiper-button-next"),
                        prevEl: slider.parentNode.querySelector(".swiper-button-prev"),
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 40,
                        },
                        1620: {
                            slidesPerView: 3,
                            spaceBetween: 60
                        }
                    },
                    centeredSlides: true,
                }

                let currentSlider = new Swiper(slider, sliderConfig);

                currentSlider.on( 'observerUpdate', () => {
                    currentSlider.destroy(currentSlider, true);
                    currentSlider = new Swiper(slider, sliderConfig);
                });
            }
        })
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        blockSliderInit();
});